import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Precious Metals initial values
export const preciousMetalsInitialValues = {
  metalType: "",
  formType: "",
  weight: "",
  weightUnit: "gram",
  purity: "",
  currentMarketPrice: "",
  estimatedCurrentValue: "",
  storageLocation: "",
  ownershipType: "",
}

// Precious Metals validation schema
export const preciousMetalsValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Min length: 3 characters")
    .max(50, "Max length: 50 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Purchase price is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"),
  metalType: Yup.string().required("Metal Type is required"),
  formType: Yup.string().required("Form / Sub-Type is required"),
  weight: Yup.number()
    .typeError("Must be a number")
    // .required("Weight / Quantity is required")
    .positive("Must be greater than 0")
    .min(0.01, "Must be greater than 0"),
  weightUnit: Yup.string().required("Weight Unit is required"),
  // purity: Yup.string().required("Purity is required"),
  currentMarketPrice: Yup.number()
    .typeError("Must be a number")
    // .required("Current Market Price is required")
    .positive("Must be greater than 0")
    .min(0.01, "Must be greater than 0"),
  estimatedCurrentValue: Yup.number()
    .typeError("Must be a number")
    .required("Estimated Current Value is required")
    .positive("Must be greater than 0")
    .min(0.01, "Must be greater than 0"),
  // ownershipType: Yup.string().required("Ownership Type is required"),
  storageLocation: Yup.string()
    // .required("Storage Location is required")
    .min(3, "Min length: 3 characters")
    .max(80, "Max length: 80 characters")
    .matches(
      /^[A-Za-z0-9 \-\&\.\'\(\)\#]+$/,
      "Allowed: letters, numbers, spaces, and - & . ' ( ) # only. No emojis, HTML, or special symbols."
    ),
})

/**
 * Precious Metals Form - Field-only component for AddAssets.js
 * This renders only the precious-metals-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const PreciousMetalsForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="precious-metals"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default PreciousMetalsForm
